import {
    ArrowDownwardRounded,
    ArrowUpwardRounded,
    SwapVertRounded,
    SyncAltRounded,
} from '@mui/icons-material';
import { IconButton } from '@mui/material';

const sortStates = ['asc', 'desc', undefined];

const Sort = ({ field, value, onChange }) => {
    return (
        <IconButton
            onClick={() =>
                onChange(field, sortStates[(sortStates.indexOf(value) + 1) % 3])
            }
        >
            {value === 'asc' && <ArrowDownwardRounded fontSize="small" />}
            {value === 'desc' && <ArrowUpwardRounded fontSize="small" />}
            {value === undefined && (
                <SyncAltRounded
                    sx={{ transform: 'rotate(90deg)' }}
                    color="disabled"
                    fontSize="small"
                />
            )}
        </IconButton>
    );
};

export default Sort;
